<div class="sum-items-container">
    <!-- <p class="text">{{ 'aumico_notes_super_table_add_calculation_title_placeholder' | i18next }}</p>

    <input
        hamInput
        [formControl]="titleControl"
        [placeholder]="'aumico_notes_super_table_text_value_placeholder' | i18next"
    /> -->

    <div class="ratio-selection">
        <span class="text"> {{ 'aumico_notes_super_table_ratio_choose_cell' | i18next }}</span>
        <div class="item-selection-flex-container">
            <div class="dropdown-options">
                <div *ngFor="let item of rowSelectionOptions" class="dropdown-item">
                    <span class="selection-col caption">
                        <span
                            class="text"
                            data-testid="calculation-item-label"
                            [hamTooltip]="item.caption"
                            [tooltipOnlyWhenTruncated]="true"
                            [tooltipAboveModals]="true"
                        >
                            {{ item.caption }}
                        </span>
                    </span>
                    <ng-container *ngFor="let col of columnSelectionOptions">
                        <span
                            *ngIf="col.type === 'CY'"
                            class="selection-col current-year"
                            [ngClass]="{
                                'selected-cell':
                                    item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id
                            }"
                            (click)="onRelationCellClick(item, col)"
                        >
                            <span
                                *ngIf="item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id"
                                class="ham-icon"
                            >
                                <i class="check-circle green"></i>
                            </span>
                            {{ item.currentValue | finNumber }}
                        </span>
                        <span
                            *ngIf="col.type === 'PV'"
                            class="selection-col previous-year"
                            [ngClass]="{
                                'selected-cell':
                                    item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id
                            }"
                            (click)="onRelationCellClick(item, col)"
                        >
                            <span
                                *ngIf="item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id"
                                class="ham-icon"
                            >
                                <i class="check-circle green"></i>
                            </span>
                            {{ item.previousValue | finNumber }}
                        </span>
                        <span
                            *ngIf="col.type === 'NUMBER' || col.type === 'CALC'"
                            class="selection-col current-year"
                            [ngClass]="{
                                'selected-cell':
                                    item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id
                            }"
                            (click)="onRelationCellClick(item, col)"
                        >
                            <span
                                *ngIf="item.name === selectedRowItem?.name && col.columnId === selectedColumnItem?.id"
                                class="ham-icon"
                            >
                                <i class="check-circle green"></i>
                            </span>
                            {{ item[col.columnId] | finNumber }}</span
                        >

                        <span
                            *ngIf="
                                col.columnId === selectedColumnItem?.id &&
                                selectedRowItem != null &&
                                selectedColumnItem != null
                            "
                            class="selection-col ratio"
                        >
                            {{ getCalculatedPercentage(item, col) | finNumber }}
                            {{ getCalculatedPercentage(item, col) != null ? '%' : '' }}
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div>
        <span class="text">{{ 'aumico_notes_super_table_enter_here' | i18next }}</span>
        <input
            placeholder="{{ 'aumico_notes_super_table_enter_here' | i18next }}"
            [options]="columnWidthSelections"
            hamSimpleDropDown
            [optionKeys]="['name']"
            returnKey="id"
            [multiple]="false"
            [formControl]="columnWidthControl"
        />
    </div>

    <div class="belonging-year-container">
        <span class="text">{{ 'aumico_notes_super_table_add_free_column_belonging_year' | i18next }}</span>
        <input
            hamSimpleDropDown
            [options]="belongingYearSelections"
            [optionKeys]="['name']"
            returnKey="id"
            [allowFreeText]="false"
            [placeholder]="'aumico_notes_super_table_add_free_column_belonging_year' | i18next"
            [multiple]="false"
            [formControl]="belongingYearControl"
        />
    </div>
</div>
